import React from 'react'
import { Link } from 'react-router-dom'

const BalanceCard = ({
  chainId,
  chainLogo,
  name,
  symbol,
  contractAddress,
  logoUrl,
  balance
}) => {
  const link = `/buy/?chain=${chainId}&address=${contractAddress}`
  return (
    <Link
      to={link}
      className="block p-4 rounded-lg transition-all"
      style={{
        background: 'var(--section-bg)',
        border: '1px solid var(--border-color)'
      }}
    >
      <div className='flex items-center gap-4'>
        <img
          src={logoUrl}
          className="w-12 h-12 rounded-full"
          alt={name}
        />
        <div className="flex-1">
          <h3 className="font-medium" style={{ color: 'var(--text-primary)' }}>
            {name}
          </h3>
          <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
            {Number(balance).toLocaleString()} {symbol.toUpperCase()}
          </p>
        </div>
        <div className="flex items-center">
          <img
            src={chainLogo}
            className="w-6 h-6"
            alt={`Chain ${chainId}`}
          />
        </div>
      </div>
    </Link>
  )
}

export default BalanceCard
